import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { ImpersonatePersonUseCaseInterface } from 'domain/usecases';
import { IMPERSONATION_RADE_PLATFORM } from 'domain/value-objects/impersonation-rade-platform';

export class RemoteImpersonatePerson
  implements ImpersonatePersonUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: ImpersonatePersonUseCaseInterface.Params,
  ): Promise<ImpersonatePersonUseCaseInterface.Result> {
    const { targetRadePlatform, profileId } = params;

    let requestUrl: string = undefined;

    switch (targetRadePlatform) {
      case IMPERSONATION_RADE_PLATFORM.GESTOR:
        requestUrl = this.url;
        break;
      case IMPERSONATION_RADE_PLATFORM.ORGANIZACAO:
        requestUrl = this.url + '/organization';
        break;
      default:
        throw new UnexpectedError('Algo de inesperado aconteceu.');
    }

    const httpResponse = await this.httpClient.request({
      url: requestUrl,
      method: 'post',
      body: { profileId: Number(profileId) },
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.created:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body?.message);
    }
  }
}
